<div class="photo-view-dialog">
  <div class="photo-view-dialog_close">
    <mat-icon svgIcon="close_icon"
    (click)="closeDialog()"></mat-icon>
  </div>
  <div class="photo-view-dialog_header-action">
    @if (userActive) {
      <button
        mat-raised-button
        class="rounded-edge"
        color="white-transparent"
        (click)="makeProfilePic(data.photos[selectedImage])">
        @if (!showSpinner) {
          Make profile picture
        }
        @if (showSpinner) {
          <mat-spinner color="primary"
          diameter="20"></mat-spinner>
        }
      </button>
    }
  </div>

  <div class="photo-view-dialog_swiper">
    <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div>
    <swiper-container #photoViewSwiper navigation='{ "nextEl": ".swiper-button-next", "prevEl": ".swiper-button-prev" }'
      [initialSlide]="selectedImage"
      [slidesPerView]="1"
      (indexChange)="onIndexChange($event)">
      @for (photo of data.photos; track photo) {
        <swiper-slide class="swiper-slide">
          <div class="image"
          [style.background-image]="'url(' + photo.path + ')'"></div>
        </swiper-slide>
      }
    </swiper-container>
  </div>

  <div class="photo-view-dialog_caption">
    @if (data.photos[selectedImage].taggedDogs) {
      @if (data.photos[selectedImage].taggedDogs.includes('and ')) {
        <p class="mat-body-medium u-text-color_white">
          {{ data.photos[selectedImage].taggedDogs }}
          <span class="u-text-weight_300">were tagged</span>
        </p>
      }
      @if (!data.photos[selectedImage].taggedDogs.includes('and ')) {
        <p class="mat-body-medium u-text-color_white">
          {{ data.photos[selectedImage].taggedDogs }}
          <span class="u-text-weight_300">was tagged</span>
        </p>
      }
    }
  </div>

  <div mat-dialog-actions
    class="photo-view-dialog_actions">
    @if (userActive) {
      <button
        mat-raised-button
        color="white-transparent"
        (click)="favouriteThisPhoto(data.photos[selectedImage])"
        [ngClass]="data.photos[selectedImage].isFavourite ? 'is-favourite' : ''">
        <mat-icon svgIcon="carousel-heart_icon"
          [ngClass]="data.photos[selectedImage].isFavourite ? 'mat-red' : ''">
        </mat-icon>Favourite
      </button>
    }
    <a mat-raised-button
      [disabled]="disable"
      color="white-transparent"
      class="mobile-menu_link"
      (click)="download(selectedImage)">
      <mat-icon svgIcon="carousel-download_icon"></mat-icon>Download
    </a>
    <button mat-raised-button
      color="white-transparent"
      (click)="shareThisPhoto(selectedImage)">
      <mat-icon svgIcon="carousel-share_icon"></mat-icon>Share
    </button>
  </div>
</div>